export default new class orderAdd {
  constructor() {
    this.sCopyBtnClass = '_copy-btn';
    this.dataCopy = 'data-copy';

    this.timeoutId = null;

    this.init();
  }

  init() {
    $(document)
      .on('click', `.${this.sCopyBtnClass}`, (event) => {
        const currentItem = event.currentTarget;
        navigator.clipboard.writeText(currentItem.getAttribute(this.dataCopy))
          .then(() => {
            clearTimeout(this.timeoutId);
            currentItem.classList.remove('text-bg-info');
            currentItem.classList.add('text-bg-success');
            currentItem.textContent = 'Код скопирован';

            this.timeoutId = setTimeout(() => {
              currentItem.classList.remove('text-bg-success');
              currentItem.classList.add('text-bg-info');
              currentItem.innerText = 'Копировать код';
            }, 2500);
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.error('Ошибка копирования:', err);
          });
      });
  }
}();
